export default function BookNow() {
  return (
    <>
      <a href="#contact-form" className="btn btn-green">Book A Demo</a>
    </>
  )
}
